export const containerCartAnimations = {
  enter: {
    x: 0,
    transition: {
      when: "beforeChildren",
      staggerChildren: 0.1,
      duration: 0.2
    }
  },
  exit: {
    x: 500,
    transition: {
      when: "afterChildren",
      staggerChildren: 0.1,
      duration: 0.2
    }
  }
};

export const childCartAnimations = {
  exit: {
    x: -10,
    opacity: 0,
    transition: {
      duration: 0.2
    }
  },
  enter: {
    x: 0,
    opacity: 1,
    transition: {
      duration: 0.2
    }
  }
};

export const checkoutAnimations = {
  exit: {
    y: 16,
    opacity: 0,
    transition: {
      duration: 0.1
    }
  },
  enter: {
    y: 0,
    opacity: 1,
    transition: {
      duration: 0.1
    }
  }
};
